// extracted by mini-css-extract-plugin
export default {"root":"mmJnwRVcSofuhU5d_Bn6","wrap":"Sai8pWaUfTrlO08BnRK9","icon":"U_Ack09ETYrROFeWCt91","copy":"UtDsh0fntFHG4wELtv4u","back":"PmgEPWcKj1zMPILzgbJ_"};